import { ModuleGridType } from 'types/global'
import type { BasicAccessorConfig } from './types'

const setter = ({ moduleGrid, value }: { moduleGrid: ModuleGridType; value: boolean }) => {
  window.editor.execute(
    new window.SetPanelConfigurationCommand(
      moduleGrid,
      'elevationAuto',
      value,
      window.Utils.generateCommandUUIDOrUseGlobal()
    )
  )
}

const getter = (moduleGrid: ModuleGridType): boolean => {
  return moduleGrid.elevationAuto
}

export const elevationAutoAccessorConfig: BasicAccessorConfig<boolean> = {
  get: getter,
  set: setter,
}
